import { render, staticRenderFns } from "./fileAgent.vue?vue&type=template&id=1c10f1fa"
import script from "./fileAgent.vue?vue&type=script&lang=ts"
export * from "./fileAgent.vue?vue&type=script&lang=ts"
import style0 from "./fileAgent.vue?vue&type=style&index=0&id=1c10f1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports